import config from '@/lib/config';
import { HttpClient } from './http-client';

export * from './errors';

// The login token is an HttpOnly cookie set by advisory-springboot (POST /public/session), so JS can't read it.
// withCredentials makes the browser send it to the API, which is on another host (advservices).
export const httpSingleton = new HttpClient({
	baseUrl: config.HACKETT_ADVISORY_BASE_URL,
	defaultHeaders: {
		'Content-Type': 'application/json',
	},
	withCredentials: true,
});
